module.exports = __webpack_public_path__ + "img/liulv.0fcf4f70.png";